/**
 * Return whether the given postal code is useable for a geo code query
 */
const getPostalCodeIsUsableForGeoCodes = (postalCode: string) => {
    if (!postalCode) {
        return false;
    }
    postalCode = `${postalCode}`;
    return [5, 10].includes(postalCode.length);
}

export default getPostalCodeIsUsableForGeoCodes;
